import React, { useState, useRef, useEffect } from "react";
import "../css/ImageMagnifier.css";

const ImageMagnifier = ({ src, zoom = 2 }) => {
  const [backgroundPosition, setBackgroundPosition] = useState("50% 50%");
  const [isHovering, setIsHovering] = useState(false);
  const imgRef = useRef(null);
  const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 768);

  useEffect(() => {
    const handleResize = () => setIsDesktop(window.innerWidth >= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleMouseMove = (e) => {
    const { left, top, width, height } = imgRef.current.getBoundingClientRect();
    const x = ((e.pageX - left - window.scrollX) / width) * 100;
    const y = ((e.pageY - top - window.scrollY) / height) * 100;
    setBackgroundPosition(`${x}% ${y}%`);
  };

  if (!isDesktop) {
    return (
      <img
        src={src}
        alt="Product"
        className="img-fluid mb-3 border rounded main-image"
      />
    );
  }

  return (
    <div
      className="magnifier-inplace"
      ref={imgRef}
      style={{
        backgroundImage: `url("${src.startsWith('/') ? process.env.REACT_APP_API_URL + src : src}")`,
        backgroundSize: isHovering ? `${zoom * 100}%` : "100%",
        backgroundPosition: backgroundPosition,
      }}
      onMouseEnter={() => setIsHovering(true)}
      onMouseLeave={() => setIsHovering(false)}
      onMouseMove={handleMouseMove}
    />
  );
};

export default ImageMagnifier;
